export default __webpack_public_path__ + "static/media/certify.b9341a2d.svg";